import { useCallback, useMemo } from 'react';

function useDeviceTimeSeriesZoom({ enabledZoom, onZoomComplete }) {
  const handleZoomStart = useCallback(({ chart, point }) => {
    disableMarkerPlugin(chart);

    return chart.isPointInArea(point);
  }, []);
  const handleZoomComplete = useCallback(
    (event) => {
      enableMarkerPlugin(event.chart);

      if (onZoomComplete) {
        onZoomComplete(event);
      }
    },
    [onZoomComplete]
  );
  const handleZoomRejected = useCallback((event) => {
    enableMarkerPlugin(event.chart);
  }, []);

  return useMemo(
    () => ({
      limits: {
        x: { min: 'original', max: 'original', minRange: 60 * 60 * 1000 }
      },
      zoom: {
        wheel: {
          enabled: false
        },
        pinch: {
          enabled: false
        },
        drag: {
          enabled: enabledZoom,
          threshold: 5,
          backgroundColor: 'rgba(6, 116, 159, 0.18)',
          borderColor: 'rgba(0, 80, 130, 1)',
          borderWidth: 1
        },
        mode: 'x',
        onZoomStart: handleZoomStart,
        onZoomComplete: handleZoomComplete,
        onZoomRejected: handleZoomRejected
      },
      pan: {
        enabled: false
      }
    }),
    [enabledZoom, handleZoomStart, handleZoomComplete, handleZoomRejected]
  );
}

function enableMarkerPlugin(chart) {
  if (chart.options.plugins.marker) {
    chart.options.plugins.marker.enabled = true;
  }
}

function disableMarkerPlugin(chart) {
  if (chart.options.plugins.marker) {
    chart.options.plugins.marker.enabled = false;
  }
}

export { useDeviceTimeSeriesZoom };
